<template>
  <div
    class="sib-file-select-wrapper"
    :class="{ 'sib-file-select-wrapper--loading': $props.loading }"
  >
    <label :class="classes" class="sib-button sib-button--default" :for="id">
      <div v-if="$props.loading" class="sib-file-select-loading lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      {{ text }}
    </label>
    <input
      class="sib-file-select-input"
      type="file"
      :accept="accept"
      v-bind="$attrs"
      :id="id"
      :name="id"
      :required="required"
    />
  </div>
</template>

<script lang="ts">
export default {
  inheritAttrs: false,
}
</script>

<script setup lang="ts">
import { computed } from 'vue'
import { UIKitRole, UIKitRound, UIKitSize } from './types'

interface FileselectProps {
  id: string
  text?: string
  role?: UIKitRole
  size?: UIKitSize
  round?: UIKitRound
  loading?: boolean
  accept?: string
  required?: boolean
}

const props = withDefaults(defineProps<FileselectProps>(), {
  role: 'default',
  size: 'md',
  round: 'none',
  text: 'Select Image',
  loading: false,
  accept: 'image/*',
  required: false,
})

const baseClass = 'sib-file-select'

const classes = computed(() => {
  const classes = [baseClass]
  if (props.role) {
    classes.push(`${baseClass}--role-${props.role}`)
  }
  if (props.size) {
    classes.push(`${baseClass}--size-${props.size}`)
  }
  if (props.round) {
    classes.push(`${baseClass}--round-${props.round}`)
  }
  return classes
})
</script>
